import { CommandGroup, CommandItem } from '@/components/ui/command';
import { Urls } from '@/lib/urls';
import { useSignOut } from '@/providers/session-provider/hooks/use-sign-out';
import {
  ArrowRightIcon,
  CogIcon,
  CopyIcon,
  LogOutIcon,
  SearchIcon,
  UserIcon,
} from 'lucide-react';
import { useRouter } from 'next/navigation';
import type { Dispatch, SetStateAction } from 'react';
import { toast } from 'sonner';
import type { Page } from '..';

interface Props {
  setPages: Dispatch<SetStateAction<Page[]>>;
  setSearch: Dispatch<SetStateAction<string>>;
  onClose: () => void;
}

export function GlobalSearchCommandGroups({
  setPages,
  setSearch,
  onClose,
}: Props) {
  const router = useRouter();
  const signOut = useSignOut();
  const handleSelect = (path: string) => {
    router.push(path);
    onClose();
  };
  async function copyCurrentUrl() {
    try {
      await navigator.clipboard.writeText(window.location.href);
      toast.success('URL kopierad till urklipp');
    } catch {
      toast.error('URL kunde inte kopieras till urklipp');
    }
    onClose();
  }
  return (
    <>
      <CommandGroup heading='Global sök'>
        <CommandItem
          onSelect={() => {
            setPages((pages) => [...pages, 'searchable-models']);
            setSearch('');
          }}
        >
          <SearchIcon className='mr-2 size-4' />
          <span>Sök bland objekt</span>
        </CommandItem>
      </CommandGroup>
      <CommandGroup heading='Navigering'>
        <CommandItem
          onSelect={() => {
            setPages((pages) => [...pages, 'navigation']);
            setSearch('');
          }}
        >
          <ArrowRightIcon className='mr-2 size-4' />
          <span>Navigera bland objekt</span>
        </CommandItem>
      </CommandGroup>
      <CommandGroup heading='Övrigt'>
        <CommandItem onSelect={copyCurrentUrl}>
          <CopyIcon className='mr-2 size-4' />
          <span>Kopiera nuvarande URL</span>
        </CommandItem>
      </CommandGroup>
      <CommandGroup heading='Inställningar'>
        <CommandItem
          onSelect={() => {
            setPages((prev) => [...prev, 'theme']);
            setSearch('');
          }}
        >
          <CogIcon className='mr-2 size-4' />
          <span>Byt tema</span>
        </CommandItem>
      </CommandGroup>
      <CommandGroup heading='Konto'>
        <CommandItem
          onSelect={() => handleSelect(Urls.settings.profile.settings)}
        >
          <UserIcon className='mr-2 size-4' />
          <span>Profilinställningar</span>
        </CommandItem>
        <CommandItem
          className='text-destructive aria-selected:bg-destructive/10 aria-selected:text-destructive'
          onSelect={() => {
            onClose();
            signOut();
          }}
        >
          <LogOutIcon className='mr-2 size-4' />
          <span>Logga ut</span>
        </CommandItem>
      </CommandGroup>
    </>
  );
}
